import { render } from "./TheFooter.vue?vue&type=template&id=7abc9bc1&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=7abc9bc1&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abc9bc1"]])

export default __exports__